import apiUrl from '../../../constants';
import axios from 'axios';
import { BasicSelect } from 'vue-search-select';
import PushBagDetails from './PushBagDetails/index.vue';
import BagInscanLogs from './BagInscanLogs/index.vue';
import HubMapping from './HubMapping/index.vue';
import PushDetails from './PushDetails/index.vue';

export default {
	name: 'sorter',
	components: {
		BasicSelect,
		'first': PushBagDetails,
		'second': BagInscanLogs,
		'third': HubMapping,
		'Fourth' : PushDetails
	},
	props: [],
	data() {
		return {
			hubLoading: '',
			hubid: "",
			hubname: '',
			hubData: {
				value: "",
				text: ""
			},
			DestHubNameData: [],
			currentTab: 'First',
			componentKey: 0,
			tabs:
				[
					{
						key: 'First',
						value: 'Push Bag Details'
					},
					{
						key: 'Second',
						value: 'Bag Inscan Logs'
					},
					{
						key: 'Third',
						value: 'Hub Mapping'
					},
					{
						key: 'Fourth',
						value: 'Push Details'
					}
				],
		}
	},
	computed: {
		currentTabComponent: function () {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {
		this.getSorterHubNames();
	},
	methods: {
		selectedHub(hubData) {
			this.hubData = hubData
			this.hubid = hubData.value
			this.hubname = hubData.text.split('(')[0].trim()
			this.currentTab = 'First'
		},
		getSorterHubNames() {
			this.DestHubNameData = []
			this.hubLoading = 'Loading Hubs...'
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.hubLoading = ''
					const HubNameData = result.data.ResponseData
					for (const element of HubNameData) {
						this.DestHubNameData.push({
							value: element.HubID,
							text: element.HubName + ' (' + element.HubID + ')'
						})
					}
				}, error => {
					this.hubLoading = ''
					console.error(error)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BagSorter/BagSorter.js